





































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { Board, BoardActionsKeys, BoardActionsPayload } from '@/store/types/board';
import { Session, SessionActionsKeys, SessionActionsPayload } from '@/store/types/session';
import API from '@/plugins/axios';

@Component({})
export default class Dashboard extends Vue {
  @Action(BoardActionsKeys.OPEN_BOARD) openBoard!: (payload: BoardActionsPayload['OPEN_BOARD']) => void;
  @Action(SessionActionsKeys.LOAD_SESSION) loadSession!: (payload: SessionActionsPayload['LOAD_SESSION']) => void;
  @Action(BoardActionsKeys.ACCEPT_SHARED_BOARD) acceptSharedBoard!: (
    payload: BoardActionsPayload['ACCEPT_SHARED_BOARD']
  ) => Promise<number | false>;

  get learningAppUrl() {
    return `${process.env.VUE_APP_LEARNING_URL}?search_term=${btoa(this.search)}`;
  }
  get communicatorAppUrl() {
    return `${process.env.VUE_APP_COMMUNICATOR_URL}?search_term=${btoa(this.search)}`;
  }

  autocompleteValue = '';
  search = '';
  loading = false;
  _timerId!: NodeJS.Timeout;
  items = [] as unknown[];
  navItems = [
    {
      title: 'Learning App',
      href: process.env.VUE_APP_LEARNING_URL,
      icon: '/icons/icon_learningapp.svg',
    },
    {
      title: 'Communicator',
      href: process.env.VUE_APP_COMMUNICATOR_URL,
      icon: '/icons/icon_communicator.svg',
    },
    {
      title: 'ILP',
      href: process.env.VUE_APP_ILP_URL,
      icon: '/icons/icon_ilp.svg',
    },
    {
      title: 'MyTrailMap',
      href: process.env.VUE_APP_PROSYS_URL,
      icon: '/icons/prosys_logo.svg',
    },
  ];

  @Watch('search')
  async loadItems(searchVal: string) {
    clearTimeout(this._timerId);
    if (searchVal && searchVal.trim() && searchVal.trim().length >= 3) {
      this.loading = true;
      this._timerId = setTimeout(async () => {
        try {
          const data = await Promise.all([this.getBoards(), this.getSessions(), this.getSharedBoards()]);
          this.items = [];
          if (data[0].length) this.items.push({ header: 'Boards' }, ...data[0]);
          if (data[1].length) this.items.push({ header: 'Sessions' }, ...data[1]);
          if (data[2].length) this.items.push({ header: 'Shared with you' }, ...data[2]);
        } catch {
          this.items = [];
        }
        this.loading = false;
      }, 500);
    } else {
      this.items = [];
    }
  }

  async getSessions() {
    const { data } = await API.post('/api/session/search', {
      for: this.search.trim(),
    });
    return data.items.map((s: Session & { session_id: number }) => ({
      text: s.name,
      value: s.session_id,
      type: 'session',
      favorite: null,
    }));
  }
  async getBoards() {
    const { data } = await API.post('/api/board/search', {
      for: this.search.trim(),
    });
    return data.items.map((b: Board & { favorite_id?: number }) => ({
      text: b.name,
      value: b.id,
      type: 'board',
      favorite: !!b.favorite_id,
    }));
  }
  async getSharedBoards() {
    const { data } = await API.post('/api/board/shared_search', {
      for: this.search.trim(),
    });
    return data.items.map((b: Board & { favorite_id?: number }) => ({
      text: b.name,
      value: b.id,
      type: 'shared_board',
      favorite: !!b.favorite_id,
    }));
  }

  openItem(id: number, type: 'board' | 'session' | 'shared_board') {
    if (type === 'board') {
      this.openBoard({ id });
    } else if (type === 'shared_board') {
      this.openBoard({ id, shared: true });
    } else {
      this.loadSession(id);
    }
  }

  async mounted() {
    const searchTerm = localStorage.getItem('search_term');
    if (searchTerm) {
      try {
        const search = atob(searchTerm);
        this.autocompleteValue = search || '';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.$refs.autocomplete as any).focus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.$refs.autocomplete as any).activateMenu();
      } catch {
        console.log('not properly parsed');
      }
      localStorage.removeItem('search_term');
    }
    const boardUuid = localStorage.getItem('board_uuid');
    if (boardUuid) {
      const id = await this.acceptSharedBoard(boardUuid);
      localStorage.removeItem('board_uuid');
      if (id) {
        this.openBoard({ id, shared: true });
      }
    }
  }
}
